import React, { useEffect } from 'react';
import { DialogContent, DialogOverlay } from './Dialog.style';

type DialogProps = {
  children: React.ReactNode;
  minWidth?: string;
  maxWidth?: string;
  minHeight?: string;
  borderRadius?: string;
  showOverlay?: boolean;
  zIndex?: number;
};

const Dialog = ({
  children,
  showOverlay = true,
  zIndex,
  ...props
}: DialogProps) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <>
      {showOverlay && <DialogOverlay zIndex={zIndex} />}
      <DialogContent zIndex={zIndex} {...props}>
        {children}
      </DialogContent>
    </>
  );
};

export default Dialog;
